import { Box, CircularProgress } from "@mui/material";

export type CenteredSpinnerProps = {
  /** MUI spacing on the wrapper Box. Defaults to 4. */
  padding?: number;
  /** Forwarded to CircularProgress; defaults to MUI's own default. */
  size?: number;
};

export const CenteredSpinner = ({
  padding = 4,
  size,
}: CenteredSpinnerProps) => (
  <Box sx={{ display: "flex", justifyContent: "center", p: padding }}>
    <CircularProgress size={size} />
  </Box>
);
